import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedUserNavOverridesAtom } from '@/atoms/queries/user';
import { DATA_LOCKER_LANDING_PAGE_TAB } from '@/consts/searchKeys';
import { DataLockerSelectedTab } from '@/types/tabs';
import { BASE_CLASSIC_EXPLORE_ROUTE } from '@/utils/classicLinks';

const useNewExploreNavigationItems = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');

  return [
    {
      id: 'explore-player-scout',
      label: t('crossPlatform.secondary.playerScout'),
      route: `/${locale}/data-locker?${DATA_LOCKER_LANDING_PAGE_TAB}=${DataLockerSelectedTab.PLAYER}`,
    },
  ];
};

const useOldExploreNavigationItems = () => {
  const { t } = useTranslation('navigation');

  return [
    {
      id: 'explore-player-scout-men',
      label: t('crossPlatform.secondary.playerScoutMen'),
      route: `${BASE_CLASSIC_EXPLORE_ROUTE}/men`,
    },
    {
      id: 'explore-player-scout-women',
      label: t('crossPlatform.secondary.playerScoutWomen'),
      route: `${BASE_CLASSIC_EXPLORE_ROUTE}/women`,
    },
  ];
};

export const useExploreNavigationItems = (): {
  id: string;
  label: string;
  route: string;
  onClick?: () => void;
}[] => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');
  const isClassicPlayerScoutXp = useAtomValue(unwrappedUserNavOverridesAtom).playerScout;
  const newExploreNavigationItems = useNewExploreNavigationItems();
  const oldExploreNavigationItems = useOldExploreNavigationItems();
  const playerScoutItems = isClassicPlayerScoutXp ? oldExploreNavigationItems : newExploreNavigationItems;

  return [
    ...playerScoutItems,
    {
      id: 'explore-teams',
      label: t('crossPlatform.secondary.teams'),
      route: `/${locale}/data-locker?${DATA_LOCKER_LANDING_PAGE_TAB}=${DataLockerSelectedTab.TEAM}`,
    },
    {
      id: 'explore-events',
      label: t('crossPlatform.secondary.events'),

      route: `/${locale}/data-locker?${DATA_LOCKER_LANDING_PAGE_TAB}=${DataLockerSelectedTab.EVENTS}`,
    },
  ];
};
